import { Static, Type } from '@sinclair/typebox'
import { Flow } from '../flows'
import { AiBuilderMessage } from '.'
import { FlowVersion } from '../flows/flow-version'

export const CreateAiBuilderReviewRequest = Type.Object({
    flow: Flow,
    history: Type.Array(AiBuilderMessage),
    flowVersion: FlowVersion,
    rating: Type.Number(),
    comment: Type.String(),
})

export type CreateAiBuilderReviewRequest = Static<typeof CreateAiBuilderReviewRequest>